import cx from 'classnames';
import {type MouseEvent, useCallback} from 'react';
import {VariantType} from '~/GalleryPB/types/template';
import {Button} from '~library/atoms/Button';

import './Footer.sass';

type FooterProps = {
  variant: VariantType;
  onStartCustomizingClick: (e: MouseEvent<HTMLButtonElement>, variant: VariantType) => void;
  isPremiumTemplate: boolean;
  highlightFree: boolean;
};

export const Footer = ({
  variant,
  highlightFree,
  onStartCustomizingClick,
  isPremiumTemplate,
}: FooterProps) => {
  const onButtonClick = useCallback(
    (variant: VariantType) => (e: MouseEvent<HTMLButtonElement>) =>
      onStartCustomizingClick(e, variant),
    [onStartCustomizingClick]
  );

  return (
    <div
      className={cx('quick-view__footer', {
        'quick-view__footer--highlight-free': highlightFree,
      })}
    >
      {variant === VariantType.FREE ? (
        <>
          {!isPremiumTemplate && (
            <Button
              variant={highlightFree ? 'primary' : 'secondary'}
              data-qa-id="quick-modal-free-btn"
              data-impression-tracking="true"
              size="large"
              className="quick-view__footer__button"
              onClick={onButtonClick(VariantType.FREE)}
            >
              Start with Free
            </Button>
          )}
          <Button
            variant={highlightFree ? 'secondary' : 'primary'}
            data-qa-id="quick-modal-go-premium-btn"
            data-impression-tracking="true"
            size="large"
            className="quick-view__footer__button"
            onClick={onButtonClick(VariantType.PREMIUM)}
          >
            Go Premium
          </Button>
        </>
      ) : (
        <Button
          variant="primary"
          data-qa-id={isPremiumTemplate ? 'qv-modal-customize' : 'qv-modal-freemium'}
          data-impression-tracking="true"
          size="large"
          className="quick-view__footer__button"
          onClick={onButtonClick(VariantType.PREMIUM)}
        >
          {isPremiumTemplate ? 'Customize' : 'Start with Premium'}
        </Button>
      )}
    </div>
  );
};
